/** @param {string} column Oracle column name e.g. ASSIGNMENT_STATUS_TYPE */
export function friendlyLabel(column) {
  return String(column || '')
    .toLowerCase()
    .split('_')
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : ''))
    .join(' ')
    .trim();
}
